import {Action, createReducer, on} from '@ngrx/store';
// import {BloodBankStore} from '../../models/store/user/patient';

// TODO: Add Interfaces

import {editBloodBank, loadBloodBanks, paginateBloodBanks, removeAllBloodBanks, removeBloodBanks} from 'src/actions/user/bloodBank.action';

export const initialState: any = {
  fetching: false,
  data: {
    bloodBanks: [],
    totalDocuments: 0
  }
};

const bloodBanksReducer = createReducer(initialState,
  on(loadBloodBanks, (state, {payload, totalDocuments}) => (
    {
      ...state,
      data: {
        ...state.data,
        bloodBanks: [
          ...state.data.bloodBanks,
          ...payload.filter(p => !state.data.bloodBanks.find((ds: any) => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editBloodBank, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        bloodBanks: state.data.bloodBanks.map(
          (data: any) => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeBloodBanks, (state, {payload}) => (
    {
      ...state,
      data: {
        ...state.data,
        bloodBanks: state.data.bloodBanks
          .filter((d: any) => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllBloodBanks, (state) => (
      {
        ...state,
        data: {
          ...state.data,
          bloodBanks: [],
          totalDocuments: 0
        }
      }
    )
  ),
  on(paginateBloodBanks, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return bloodBanksReducer(state, action);
}
